import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IIhmLoginTokenInfoState {
    _ihmLoginToken?: string
    _ihmIIBRefreshToken?: string
    _ihmLoginIdToken?: string
    _ihmIIBIdToken?: string
    _tokenType?: string
    _ihmLoginTokenScopes?: string
    _isLoggedIn?: boolean
}

const initialState: IIhmLoginTokenInfoState = {
    _ihmLoginToken: null,
    _ihmIIBIdToken: null,
    _ihmLoginIdToken: null,
    _ihmIIBRefreshToken: null,
    _tokenType: null,
    _ihmLoginTokenScopes: null,
    _isLoggedIn: false,
}

export const ihmLoginTokenInfoSlice = createSlice({
    name: 'ihmLoginTokenInfoSlice',
    initialState,
    reducers: {
        setIhmLoginTokenInfo: (state, action: PayloadAction<IIhmLoginTokenInfoState>) => {
            state._ihmLoginToken = action.payload._ihmLoginToken
            state._ihmLoginIdToken = action.payload._ihmLoginIdToken
            state._tokenType = action.payload._tokenType
            state._ihmLoginTokenScopes = action.payload._ihmLoginTokenScopes
        },
        setIhmIIBTokenInfo: (state, action: PayloadAction<IIhmLoginTokenInfoState>) => {
            state._ihmIIBRefreshToken = action.payload._ihmIIBRefreshToken
            state._ihmIIBIdToken = action.payload._ihmIIBIdToken
            state._tokenType = action.payload._tokenType
        },
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state._isLoggedIn = action.payload
        },
    },
})

export const {
    setIhmLoginTokenInfo,
    setIhmIIBTokenInfo,
    setIsLoggedIn,
} = ihmLoginTokenInfoSlice.actions

export default ihmLoginTokenInfoSlice.reducer
